import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ActionsPage } from './pages/ActionsPage';
import { ImpactPage } from './pages/ImpactPage';
import { BlogPage } from './pages/BlogPage';
import { ArticlePage } from './pages/ArticlePage';
import { DonatePage } from './pages/DonatePage';
import { PartnerPage } from './pages/PartnerPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { FormateursPage } from './pages/FormateursPage';
import { BenevolesPage } from './pages/BenevolesPage';
import { PromaisonPage } from './pages/PromaisonPage';
import { PromaisonPopup } from './components/PromaisonPopup';
import { InscriptionPage } from './pages/InscriptionPage';
// ScrollToTop component to ensure page starts at top on navigation
function ScrollToTop() {
  const {
    useLocation
  } = require('react-router-dom');
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0" data-mp="3mj6lg27aoaim">
      <ScrollToTop data-id="element-1" data-mp="3rcj6k2crlz6m" />
      <PromaisonPopup data-id="element-2" data-mp="3rbzo8kj7d8s2" />
      <Routes data-id="element-3" data-mp="3rcsxpt9jqcdw">
        <Route path="/" element={<HomePage data-id="element-5" data-mp="5yjetptzbev" />} data-id="element-4" data-mp="3rd18nfm3z7mg" />
        <Route path="/about" element={<AboutPage data-id="element-7" data-mp="4n725ibkvc5" />} data-id="element-6" data-mp="6hpnd64cbd2" />
        <Route path="/actions" element={<ActionsPage data-id="element-9" data-mp="2zld2jatxbhc2" />} data-id="element-8" data-mp="82kl3wchwbg" />
        <Route path="/impact" element={<ImpactPage data-id="element-11" data-mp="2zmwguvw0rib7" />} data-id="element-10" data-mp="2zm4zaoz9bl3x" />
        <Route path="/blog" element={<BlogPage data-id="element-13" data-mp="33lwxq8uxsavk" />} data-id="element-12" data-mp="33mou3lwcycmw" />
        <Route path="/blog/article/:id" element={<ArticlePage data-id="element-15" data-mp="33oi0r16z0wuw" />} data-id="element-14" data-mp="33nggq77z9011" />
        <Route path="/donate" element={<DonatePage data-id="element-17" data-mp="38l05i12awv78" />} data-id="element-16" data-mp="38l8gfnev5qfs" />
        <Route path="/partner" element={<PartnerPage data-id="element-19" data-mp="3dkl58dpap7l0" />} data-id="element-18" data-mp="38nunzn1r85y0" />
        <Route path="/admin" element={<AdminDashboard data-id="element-21" data-mp="3dm5xtxs1ugg8" />} data-id="element-20" data-mp="3dlw6a5rcw18f" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-23" data-mp="nuhgse7ce3s6" />} data-id="element-22" data-mp="nvj5hlha6osd" />
        <Route path="/formateurs" element={<FormateursPage data-id="element-25" data-mp="sudl6ejybx89" />} data-id="element-24" data-mp="nvaszup2llhp" />
        <Route path="/benevoles" element={<BenevolesPage data-id="element-27" data-mp="ssss6tdacmci" />} data-id="element-26" data-mp="stkne32z0i29" />
        <Route path="/promaison" element={<PromaisonPage data-id="element-29" data-mp="35gkz19r83iz" />} data-id="element-28" data-mp="36hw15qrsq0p" />
        <Route path="/inscription" element={<InscriptionPage data-id="element-31" data-mp="3uct2xiigokzy" />} data-id="element-30" data-mp="34nabp7octvk" />
      </Routes>
    </Router>;
}